// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .password-conditions {
  margin-top: -0.3em;
  text-align: left;
}
app-root .password-conditions .rule-indicator {
  display: block;
  font-size: 0.8em;
  will-change: color;
  transition: color 0.2s ease-in-out;
}
app-root .password-conditions .rule-indicator + .rule-indicator {
  margin-top: 0.2em;
}
app-root .password-conditions .rule-indicator svg {
  position: relative;
  top: 0.15em;
}
app-root .password-conditions .rule-indicator .rule-text {
  margin-left: 0.3em;
}
app-root .password-conditions .rule-indicator.neutral {
  color: var(--border-grey);
}
app-root .password-conditions .rule-indicator.valid {
  color: #1da8af;
}
app-root .password-conditions .rule-indicator.invalid {
  color: var(--primary);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Inputs/Password/SelfValidating/PasswordInput.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,gBAAA;AAAJ;AAHA;EAKM,cAAA;EACA,gBAAA;EAYA,kBAAA;EACA,kCAAA;AAVN;AAFM;EACE,iBAAA;AAIR;AAZA;EAWQ,kBAAA;EACA,WAAA;AAIR;AAhBA;EAeQ,kBAAA;AAIR;AAEM;EACE,yBAAA;AAAR;AAEM;EACE,cAAA;AAAR;AAEM;EACE,qBAAA;AAAR","sourcesContent":["app-root {\n  .password-conditions {\n    margin-top: -0.3em;\n    text-align: left;\n    .rule-indicator {\n      display: block;\n      font-size: 0.8em;\n      & + .rule-indicator {\n        margin-top: 0.2em;\n      }\n      svg {\n        position: relative;\n        top: 0.15em;\n      }\n      .rule-text {\n        margin-left: 0.3em;\n      }\n\n      will-change: color;\n      transition: color 0.2s ease-in-out;\n\n      &.neutral {\n        color: var(--border-grey);\n      }\n      &.valid {\n        color: #1da8af;\n      }\n      &.invalid {\n        color: var(--primary);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
